module.exports = __webpack_public_path__ + "82e5b0d7a3ed3dd595eee8bfec30c70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/gonglue/fo.png
// module id = 1110
// module chunks = 0